export const faqsPl = [
  {
    q: "Nie mam jeszcze urządzenia - czy możecie zacząć od zera?",
    a: "Tak. Wiele naszych projektów zaczyna się od samego pomysłu. Pomagamy dobrać odpowiedni chip BLE, czujniki i komponenty, a następnie budujemy pierwszy działający prototyp od podstaw.",
  },
  {
    q: "Ile trwa zbudowanie pierwszego prototypu?",
    a: "Prosty prototyp na płytce deweloperskiej z podstawową funkcjonalnością BLE można zbudować w 3-6 tygodni. Bardziej złożone urządzenia, np. wearable z własną obudową lub produkt zgodny z Auracast, mogą zająć od 2 do 4 miesięcy.",
  },
  {
    q: "Czy prototyp będzie działał na baterii tak jak finalny produkt?",
    a: "Dążymy do tego, żeby prototyp jak najlepiej odzwierciedlał docelowy czas pracy na baterii - profilujemy pobór prądu i dobieramy tryby uśpienia już na etapie prototypu, a nie dopiero w produkcji.",
  },
  {
    q: "Czy zajmujecie się też beaconami iBeacon i Eddystone?",
    a: "Tak. Konfigurujemy rozgłaszanie, interwały reklamowe i moc sygnału pod konkretny scenariusz - nawigację w budynku, marketing kontekstowy czy śledzenie zasobów - i testujemy zasięg w realnych warunkach.",
  },
  {
    q: "Co to jest Bluetooth LE Audio i Auracast, i czy warto już teraz o tym myśleć?",
    a: "Bluetooth LE Audio to nowy standard audio dla BLE, a Auracast pozwala bezprzewodowo rozgłaszać dźwięk do wielu odbiorników jednocześnie (np. w salach konferencyjnych, na lotniskach czy w aparatach słuchowych). Jeśli budujesz produkt audio, warto zaplanować zgodność z LE Audio już na etapie prototypu, zanim standard stanie się powszechny.",
  },
  {
    q: "Czy pomożecie przejść od prototypu do produkcji seryjnej?",
    a: "Tak. Przygotowujemy plan przejścia do własnego PCB i obudowy, pomagamy dobrać podwykonawcę produkcyjnego oraz doradzamy w zakresie certyfikacji CE i kwalifikacji Bluetooth SIG.",
  },
  {
    q: "Czy budujecie też aplikację mobilną do prototypu?",
    a: "Tak. Budujemy aplikację towarzyszącą, która pozwala testować urządzenie z użytkownikami - podgląd danych z sensorów, konfigurację urządzenia i aktualizacje firmware.",
  },
  {
    q: "Czy podpisujecie NDA przed rozmową o pomyśle?",
    a: "Tak. Rozumiemy, że pomysł na urządzenie to często najcenniejszy zasób na wczesnym etapie. Możemy podpisać NDA przed pierwszą szczegółową rozmową - korzystamy z własnego wzoru lub pracujemy na dokumencie klienta.",
  },
  {
    q: "Od czego zależy koszt zbudowania prototypu?",
    a: "Od złożoności urządzenia, liczby czujników i komponentów, wymagań dotyczących obudowy i ergonomii, a także zakresu aplikacji mobilnej. Wypełnij formularz, by uzyskać wstępną wycenę.",
  },
] as const;
